import sportsApi from '../../utils/sportsApi';

export const fetchAuthorizedAccounts = async (clientId: number) => {
    return await sportsApi
        .url(`/clients/${clientId}/authorized-accounts`)
        .get()
        .json();
};
